// web/src/hooks/useFirestoreScoredGames.ts
import { useEffect, useState } from "react";
import { collection, getCountFromServer } from "firebase/firestore";
import { db } from "@/lib/firebase";
export const useFirestoreScoredGames = () => {
  const [scoredGames, setScoredGames] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const coll = collection(db, "dbGameResults");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count;
        // We add 79 to match the old count with /dbMVPlayer/dbStats/gameCounter
        setScoredGames(count + 79);
      } catch (err: any) {
        console.error("Error fetching scoredGames:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCount();
  }, []);
  return {
    scoredGames,
    loading,
    error
  };
};